// removed by extract-text-webpack-plugin
module.exports = {"mapContainer":"map-module__mapContainer___3HJNW","navigationControlBtns":"map-module__navigationControlBtns___2rBWn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/map/map.module.scss
// module id = 1394
// module chunks = 0